import React, { Component } from "react";

const HIT_TEST_OPTIONS = {
  segments: true,
  stroke: false,
  fill: false,
  tolerance: 4
};

export default function withFastPenTool(WrappedComponent) {
  return class extends Component {
    constructor(props) {
      super(props);
      this._path = null;
    }

    keyUp = (e) => {
      const { key } = e;
      if (this._path && key === "escape") {
        this._path.remove();
        this._path = null;
      }
    };

    mouseDown = (e) => {
      this.props.deselectItem();
      if (!this._path) {
        const paper = e.tool._scope;
        this._path = new paper.Path({
          segments: [e.point],
          strokeColor: "red",
          strokeScaling: false,
          strokeWidth: 2,
          selected: true
        });
      } else {
        const hit = e.tool.view._project.hitTest(e.point, HIT_TEST_OPTIONS);

        if (
          (hit &&
            hit.point &&
            hit.point.x === hit.item.firstSegment.point.x &&
            hit.point.y === hit.item.firstSegment.point.y) ||
          e.modifiers.control
        ) {
          this._path.removeSegment(this._path.lastSegment.index);

          this._path.layer.data.id = 1;
          const item = this.props.addItem(this._path.layer, {
            type: "Path",
            pathData: this._path.getPathData(),
            strokeColor: this._path.style.strokeColor.toCSS(true),
            strokeScaling: this._path.strokeScaling,
            strokeWidth: this._path.strokeWidth,
            closed: true,
            relatedCurvePoints: this._path.getSegments().map((seg) => {
              return { x: seg.point.x, y: seg.point.y };
            })
          });
          this.props.selectItem(item);
          this._path.remove();
          this._path = null;
        } else if (this._path) {
          this._path.add(e.point);
        }
      }
    };

    mouseMove = (e) => {
      if (this._path) {
        if (this._path.lastSegment && this._path.lastSegment.index > 0) {
          this._path.removeSegment(this._path.lastSegment.index);
        }

        this._path.add(e.point);
      }
    };

    render() {
      return (
        <WrappedComponent
          {...this.props}
          fastPenToolMouseDown={this.mouseDown}
          fastPenToolMouseMove={this.mouseMove}
          fastPenToolKeyUp={this.keyUp}
        />
      );
    }
  };
}
